import MUserInvitationList from './index.vue';

MUserInvitationList.install = app => {
  app.component(MUserInvitationList.name, MUserInvitationList);
};

export default MUserInvitationList;
